import { useTranslation } from 'react-i18next';
import { PricingPlanCard } from './PricingPlanCard';
import { PricingGroupKey, PricingPlan } from './pricingPlans.config';
import { StripeData } from '@/UI/Subscription/Subscription.page';

type Props = {
  groupKey: PricingGroupKey;
  plans: PricingPlan[];
  isBillingYearly: boolean;
  stripeData: StripeData;
  onFaqLink: (faqKey: string) => void;
};

export const PricingPlanGroup = ({
  groupKey,
  plans,
  isBillingYearly,
  stripeData,
  onFaqLink,
}: Props) => {
  const { t } = useTranslation('subscription_page');

  return (
    <section>
      <h2 className="mb-5 text-lg font-semibold text-foreground">
        {t(`pricing.groups.${groupKey}`)}
      </h2>
      <div className="grid grid-cols-1 items-stretch gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {plans.map((plan) => (
          <PricingPlanCard
            key={plan.key}
            plan={plan}
            isBillingYearly={isBillingYearly}
            stripeData={stripeData}
            onFaqLink={onFaqLink}
          />
        ))}
      </div>
    </section>
  );
};
